/**
 * ToutEn3D — Configurateur de devis 3D
 * Fichier : assets/configurateur-devis.js
 *
 * ═══ HYPOTHÈSES DU MODÈLE DE PRIX → chercher "PRICING" ══════════
 *   DENSITY = 0.002   g/mm³  — densité effective (calibrée opérateur)
 *   FORFAIT = 6       €      — forfait fixe par pièce (préparation)
 *   MARGIN  = 1.82           — multiplicateur de marge commerciale
 *   MIN_U   = 10      €      — plancher absolu par pièce
 *   ASSY    = 15      €      — surcoût hors gabarit plateau (250³ mm)
 *   MAT_P   → prix filament au kg  { pla:25.99, petg:25.99, ... }
 *   MAT_M   → coefficients matière { pla:1.0, petg:1.15, ... }
 *   QUAL_M  → coefficients qualité { draft:0.9, standard:1.0, fine:1.25 }
 * ══════════════════════════════════════════════════════════════════
 */
(function () {
  'use strict';
  const RES_ON = window.T3D_RES_ENABLED || false;
  const RES_L  = { proto: 'Prototype', standard: 'Standard', reinforced: 'Renforcé' };

// ══════════════════════════════════════
// STATE
// ══════════════════════════════════════
const S = {
  material:'pla', color:'Blanc', texture:'Textured',
  x:50, y:50, z:30, qty:1,
  quality:'standard', resistance:'standard', urgent:false, finish:false,
  files:[], totalSize:0, fileError:false, preview:null,
  priceMode:'volumetric', slicerData:null,
  constraints:[], rightsChecked:false
};

// ══════════════════════════════════════
// PRICING
// ══════════════════════════════════════
const DENSITY = 0.00012;
const FORFAIT = 6;
const MARGIN  = 1.82;
const MIN_U   = 10;
const ASSY    = 10;

const MAT_M = {pla:1.0, petg:1.15, abs:1.2, asa:1.25, tpu:1.6, nylon:3};
const MAT_L = {pla:'PLA', petg:'PETG', abs:'ABS', asa:'ASA', tpu:'TPU', nylon:'PA (Nylon)'};
const MAT_P = {pla:23, petg:26.5, abs:27.6, asa:28.8, tpu:36.8, nylon:102};
const QUAL_M = {draft:0.9, standard:1.0, fine:1.25};
const QUAL_L = {draft:'Rapide', standard:'Essential', fine:'Premium'};

// ── REMISES MODIFIÉES ──
function disc(q) { return q>=20?.75:q>=15?.85:q>=10?.90:q>=5?.95:1; }
function discTxt(q) {
  if(q>=20) return '−25%'; if(q>=15) return '−15%'; if(q>=10) return '−10%'; if(q>=5) return '−5%'; return '—';
}

const BED = 250;
function needsAssy(x,y,z) { return !((x<=BED&&y<=BED)||(y<=BED&&x<=BED)) || z>BED; }

function calcPrice() {
  S.x = +document.getElementById('dim-x').value || 50;
  S.y = +document.getElementById('dim-y').value || 50;
  S.z = +document.getElementById('dim-z').value || 30;

  const as = needsAssy(S.x, S.y, S.z);
  const qm = QUAL_M[S.quality];
  const mm = MAT_M[S.material];
  const d  = disc(S.qty);
  const uM = S.urgent ? 1.5 : 1;
  const fM = S.finish ? 1.3 : 1;
  // Resistance : coefficient regle dans les parametres de section (T3D_RES_M).
  // Absent, desactive, illisible ou nul -> 1 (aucun effet sur le prix).
  const rM = (RES_ON && window.T3D_RES_M && window.T3D_RES_M[S.resistance]) || 1;
  const texM = (S.texture === 'Textured') ? 1.0 : 1.05;

  let unit, modeBadge;

  if (S.priceMode === '3mf' && S.slicerData) {
    const {weightG:wG, printMinutes:pM} = S.slicerData;
    const matCost = (wG / 1000) * MAT_P[S.material] * mm;
    const macCost = pM * 0.0228;
    unit = Math.max(MIN_U, Math.round((FORFAIT + matCost + macCost) * qm * MARGIN));
    modeBadge = '<div class="price-mode-badge precise">✅ Données slicing · ±5%</div>';
  } else {
    const vol     = S.x * S.y * S.z;
    const mass_g  = vol * DENSITY;
    const matCost = (mass_g / 1000) * MAT_P[S.material] * mm;
    unit = Math.max(MIN_U, Math.round((FORFAIT + matCost) * qm * MARGIN));
    modeBadge = '<div class="price-mode-badge volumetric">📐 Estimation · ±15%</div>';
  }

  if (as) unit += ASSY;

  const mid  = Math.round(unit * S.qty * d * uM * fM * texM * rM);
  const sp   = S.slicerData ? 0.05 : 0.15;
  const minP = Math.round(mid * (1 - sp));
  const maxP = Math.round(mid * (1 + sp));

  document.getElementById('price-mode-wrap').innerHTML = modeBadge;
  document.getElementById('price-min').textContent  = minP;
  document.getElementById('price-max').textContent  = maxP;
  document.getElementById('pb-dims').textContent    = S.x+' × '+S.y+' × '+S.z+' mm';
  document.getElementById('pb-mat').textContent     = MAT_L[S.material];
  document.getElementById('pb-qty').textContent     = '× ' + S.qty;
  document.getElementById('pb-texture').textContent  = S.texture;
  document.getElementById('pb-quality').textContent = QUAL_L[S.quality];
  const pbRes = document.getElementById('pb-resistance');
  if (pbRes) pbRes.textContent = RES_L[S.resistance] || 'Standard';
  document.getElementById('pb-disc').textContent    = discTxt(S.qty);
  document.getElementById('pb-opts').textContent    =
    [S.urgent?'Prioritaire':'', S.finish?'Finition':'', as?'Assemblage':''].filter(Boolean).join(', ') || '—';
  document.getElementById('pb-total').textContent   = '~' + mid + '€';

  updateBanners(as, d, S.qty);
  updatePills(S.qty);
}

// ── PILLS MODIFIÉES — nouveaux seuils et IDs ──
function updatePills(q) {
  document.getElementById('disc-1').className  = 'disc-pill' + (q<5   ? ' active' : '');
  document.getElementById('disc-5').className  = 'disc-pill' + (q>=5 &&q<10 ? ' active' : '');
  document.getElementById('disc-10').className = 'disc-pill' + (q>=10&&q<15 ? ' active' : '');
  document.getElementById('disc-15').className = 'disc-pill' + (q>=15&&q<20 ? ' active' : '');
  document.getElementById('disc-20').className = 'disc-pill' + (q>=20 ? ' active' : '');
}

function updateBanners(as, d, q) {
  const c = document.getElementById('dynamic-banners'); if(!c) return;
  const m = [];
  if (as) m.push('<div class="banner bwarn"><span class="banner-ico">⚠️</span><div><strong>Pièce hors gabarit plateau (250×250mm)</strong> — Découpe et assemblage requis (+'+ASSY+'€/pièce inclus).</div></div>');
  if (q >= 5) {
    const p = Math.round((1-d)*100);
    m.push('<div class="banner bok"><span class="banner-ico">🎁</span><div><strong>Remise série −'+p+'%</strong> appliquée pour '+q+' pièces.</div></div>');
  }
  c.innerHTML = m.join('');
}

// ══════════════════════════════════════
// CONTRAINTES + SUGGESTION
// ══════════════════════════════════════
const MAT_SCORES = {
  pla:   {decorative:3, functional:1, strength:1, hightemp:0, outdoor:0, flexible:0, food:1, impact:1, chemical:0},
  petg:  {decorative:2, functional:2, strength:2, hightemp:1, outdoor:2, flexible:1, food:3, impact:2, chemical:1},
  abs:   {decorative:1, functional:3, strength:3, hightemp:2, outdoor:1, flexible:0, food:0, impact:2, chemical:1},
  asa:   {decorative:2, functional:3, strength:3, hightemp:2, outdoor:3, flexible:0, food:1, impact:2, chemical:1},
  tpu:   {decorative:2, functional:1, strength:1, hightemp:0, outdoor:2, flexible:3, food:1, impact:3, chemical:1},
  nylon: {decorative:0, functional:3, strength:3, hightemp:3, outdoor:2, flexible:1, food:1, impact:2, chemical:3},
};
const MAT_WHY = {
  pla:   'Idéal pour pièces décoratives intérieures, facile à imprimer',
  petg:  'Polyvalent, résistant, adapté au contact alimentaire et à l\'eau',
  abs:   'Rigide, résistant aux chocs et à la chaleur modérée (jusqu\'à ~100°C)',
  asa:   'Résistant UV et aux intempéries, recommandé pour pièces extérieures',
  tpu:   'Souple et élastique, excellente résistance aux chocs et à l\'abrasion',
  nylon: 'Haute résistance mécanique et thermique (jusqu\'à ~130°C), usage professionnel',
};

function toggleChip(chip) {
  chip.classList.toggle('active');
  const id = chip.dataset.cid;
  S.constraints = S.constraints.includes(id)
    ? S.constraints.filter(c => c !== id)
    : [...S.constraints, id];
  updateSuggestion();
}

function updateSuggestion() {
  const el = document.getElementById('mat-suggestion');

  // Toujours réinitialiser les classes de suggestion sur les cartes
  document.querySelectorAll('.sel-card').forEach(c => {
    c.classList.remove('suggest-rec','suggest-alt');
  });

  if (S.constraints.length === 0) {
    el.innerHTML = '<p class="suggest-empty">Sélectionnez au moins une contrainte ci-dessus.</p>';
    return;
  }
  const ranked = Object.keys(MAT_SCORES)
    .map(mat => {
      let score = 0, blocked = false;
      S.constraints.forEach(cid => {
        const s = MAT_SCORES[mat][cid] || 0;
        if (s === 0) blocked = true;
        score += s;
      });
      return {mat, score, blocked};
    })
    .filter(x => !x.blocked)
    .sort((a,b) => b.score - a.score);

  const top2 = (ranked.length >= 1 ? ranked : Object.keys(MAT_SCORES)
    .map(mat => ({mat, score:S.constraints.reduce((s,c)=>s+(MAT_SCORES[mat][c]||0),0), blocked:false}))
    .sort((a,b) => b.score - a.score)).slice(0, 2);

  if (top2.length === 0) {
    el.innerHTML = '<p class="suggest-empty">Aucun matériau ne réunit toutes ces contraintes — précisez dans les commentaires.</p>';
    return;
  }

  // Appliquer les classes visuelles sur les cartes matériau
  top2.forEach((x, i) => {
    const card = document.querySelector('.sel-card[data-mat="'+x.mat+'"]');
    if (card) card.classList.add(i === 0 ? 'suggest-rec' : 'suggest-alt');
  });

  el.innerHTML = '<p style="font-size:11px;color:var(--muted);margin-bottom:8px;font-style:italic">Suggestion indicative basée sur vos exigences. Votre choix final reste libre ci-dessous.</p>'
    + top2.map((x,i) => `
    <div class="suggest-item ${i===0?'top':''}">
      <span class="suggest-badge">${i===0?'🏆 Recommandé':'🥈 Alternative'}</span>
      <div>
        <div class="suggest-name">${MAT_L[x.mat]}</div>
        <div class="suggest-why">${MAT_WHY[x.mat]}</div>
      </div>
    </div>
  `).join('');
}

function applyMat(mat) {
  document.querySelectorAll('.sel-card').forEach(c => c.classList.remove('active'));
  const card = document.querySelector('.sel-card[data-mat="'+mat+'"]');
  if (card) card.classList.add('active');
  S.material = mat;
  calcPrice();
  // Scroll vers la grille matériau
  document.getElementById('material-grid').scrollIntoView({behavior:'smooth', block:'center'});
}

// ══════════════════════════════════════
// DIMENSIONS — feedback visuel > 250mm
// ══════════════════════════════════════
function updateDim() {
  const x = +document.getElementById('dim-x').value || 0;
  const y = +document.getElementById('dim-y').value || 0;
  const z = +document.getElementById('dim-z').value || 0;
  const BED = 250;

  ['dim-x','dim-y','dim-z'].forEach((id, i) => {
    const val = [x,y,z][i];
    document.getElementById(id).classList.toggle('dim-warn', val > BED);
  });

  const banner = document.getElementById('dim-banner');
  if (x > BED || y > BED || z > BED) {
    const axes = [x>BED?'Longueur ('+x+'mm)':'', y>BED?'Largeur ('+y+'mm)':'', z>BED?'Hauteur ('+z+'mm)':''].filter(Boolean).join(', ');
    banner.innerHTML = '<div class="banner bwarn" style="margin-bottom:0"><span class="banner-ico">⚠️</span><div><strong>'+axes+' dépasse 250mm</strong> — La pièce devra être découpée et assemblée (+'+ASSY+'€/pièce). Cela sera intégré dans votre devis.</div></div>';
  } else {
    banner.innerHTML = '';
  }
  calcPrice();
}

// ══════════════════════════════════════
// NAVIGATION
// ══════════════════════════════════════
function goTo(step) {
  document.querySelectorAll('.step-panel').forEach(p => p.classList.remove('active'));
  document.querySelectorAll('.step-item').forEach((s,i) => {
    s.classList.remove('active','done');
    if(i+1 < step) s.classList.add('done');
    if(i+1 === step) s.classList.add('active');
  });
  document.getElementById('panel-'+step).classList.add('active');
  const t = document.querySelector('.wrapper') || document.body;
  const top = t.getBoundingClientRect().top + window.pageYOffset - 16;
  try { window.scrollTo({top, behavior:'smooth'}); } catch(e) {}
  try { document.documentElement.scrollTop = top; } catch(e) {}
}

// Libellés lisibles des contraintes (pour l'email et le récap)
const CONSTRAINT_L = {
  decorative:'Usage décoratif', functional:'Pièce fonctionnelle', strength:'Haute résistance mécanique',
  hightemp:'Haute température (>80°C)', outdoor:'Usage extérieur / UV', flexible:'Flexibilité requise',
  food:'Contact alimentaire / eau', impact:'Résistance aux chocs', chemical:'Résistance chimique',
};

// Validation étape 2 (Usage & contraintes) — bloque tant que l'usage n'est pas décrit
function step2Next() {
  const cErr = document.getElementById('constraints-err');
  const uEl  = document.getElementById('usage');
  const uErr = document.getElementById('usage-err');
  let ok = true;
  if (S.constraints.length === 0) {
    if (cErr) cErr.style.display = 'block';
    ok = false;
  } else if (cErr) {
    cErr.style.display = 'none';
  }
  const usageVal = uEl ? uEl.value.trim() : '';
  if (usageVal.length < 3) {
    if (uErr) uErr.style.display = 'block';
    ok = false;
  } else if (uErr) {
    uErr.style.display = 'none';
  }
  if (!ok) {
    const target = document.getElementById(S.constraints.length === 0 ? 'constraint-grid' : 'usage');
    if (target) target.scrollIntoView({behavior:'smooth', block:'center'});
    return;
  }
  goTo(3);
}

function toggleRights() {
  const cb  = document.getElementById('rights-check');
  const err = document.getElementById('rights-err');
  // Toggle only if clicking the wrapper (not the checkbox itself which handles its own state)
  err.style.display = 'none';
  // Update state based on checkbox current value
  S.rightsChecked = cb.checked;
}

function step1Next() {
  // Vérifier la case droits si un fichier ou une URL est fourni
  const hasFile = S.files.length > 0;
  const hasUrl  = (document.getElementById('file-url').value || '').trim().length > 0;
  if ((hasFile || hasUrl) && !document.getElementById('rights-check').checked) {
    document.getElementById('rights-err').style.display = 'block';
    document.getElementById('rights-check').scrollIntoView({behavior:'smooth', block:'center'});
    return;
  }
  if (S.fileError) {
    alert('La taille totale dépasse 10 Mo. Retirez un fichier ou partagez un lien via le champ URL.');
    return;
  }
  goTo(2);
}

// ══════════════════════════════════════
// INTERACTIONS
// ══════════════════════════════════════
document.getElementById('material-grid').addEventListener('click', e => {
  const c = e.target.closest('.sel-card'); if(!c) return;
  document.querySelectorAll('.sel-card').forEach(x => x.classList.remove('active'));
  c.classList.add('active');
  S.material = c.dataset.mat;
  calcPrice();
});

document.getElementById('color-grid').addEventListener('click', e => {
  const s = e.target.closest('.color-swatch'); if(!s) return;
  document.querySelectorAll('.color-swatch').forEach(x => x.classList.remove('active'));
  s.classList.add('active');
  S.color = s.dataset.color;
  document.getElementById('color-label').textContent = s.dataset.color;
});

document.getElementById('quality-grid').addEventListener('click', e => {
  const p = e.target.closest('.quality-pill'); if(!p) return;
  document.querySelectorAll('.quality-pill').forEach(x => x.classList.remove('active'));
  p.classList.add('active');
  S.quality = p.dataset.q;
  calcPrice();
});

// Résistance (présent seulement si activé dans les paramètres de section)
const _resGrid = document.getElementById('resistance-grid');
if (_resGrid) _resGrid.addEventListener('click', e => {
  const p = e.target.closest('.t3d-res-pill'); if(!p) return;
  _resGrid.querySelectorAll('.t3d-res-pill').forEach(x => x.classList.remove('active'));
  p.classList.add('active');
  S.resistance = p.dataset.res;
  calcPrice();
});

function selectTexture(card) {
  document.querySelectorAll('.tex-card').forEach(c => c.classList.remove('active'));
  card.classList.add('active');
  S.texture = card.dataset.tex;
  // Affiche le notice de frais si texture spéciale
  const isBase = S.texture === 'Textured';
  const notice = document.getElementById('tex-fee-notice');
  if (notice) notice.style.display = isBase ? 'none' : 'block';
  calcPrice();
}

function updateQty(v) {
  S.qty = Math.max(1, +v || 1);
  document.getElementById('hf-quantite').value = S.qty;
  calcPrice();
}


function toggleOption(el, k) {
  el.classList.toggle('on');
  S[k] = el.classList.contains('on');
  calcPrice();
}

// ══════════════════════════════════════
// UPLOAD MULTIPLE FILES
// ══════════════════════════════════════
const MAX_TOTAL_BYTES = 10 * 1024 * 1024;  // 10 Mo total (limite FormSubmit)
const VIEWABLE = ['stl', 'obj', '3mf'];    // formats que l'apercu 3D sait lire
const MAX_FILE_BYTES  = 10 * 1024 * 1024;  // 10 Mo par fichier (= budget total : un seul fichier peut tout occuper)

function handleDrop(e) {
  e.preventDefault();
  document.getElementById('upload-zone').classList.remove('drag');
  handleFiles(e.dataTransfer.files);
}

function handleFiles(fileList) {
  Array.from(fileList).forEach(f => addFile(f));
}

function addFile(file) {
  if (S.files.some(f => f.name === file.name && f.size === file.size)) return;

  // Vérification taille par fichier (10 Mo max — budget total FormSubmit)
  if (file.size > MAX_FILE_BYTES) {
    alert('Le fichier "' + file.name + '" dépasse 10 Mo (' + (file.size/1024/1024).toFixed(1) + ' Mo). Partagez-le via un lien dans le champ URL ou le champ commentaires.');
    return;
  }

  const newTotal = S.totalSize + file.size;
  if (newTotal > MAX_TOTAL_BYTES) {
    S.fileError = true;
    renderFileList();
    updateSizeBar(newTotal);
    return;
  }

  S.files.push(file);
  S.totalSize = newTotal;
  S.fileError = false;
  renderFileList();
  updateSizeBar(S.totalSize);
  syncFileInput();

  // Si 3MF → tenter extraction slicing + dimensions en parallèle
  if (file.name.toLowerCase().endsWith('.3mf')) {
    parse3MF(file).then(d => {
      file._slicerData = d;
      S.slicerData = d;
      S.priceMode = '3mf';
      renderFileList();
      showSlicerResult(d);
      calcPrice();
    }).catch(() => { calcPrice(); });
  }

  // Extraction automatique des dimensions pour STL, OBJ, 3MF.
  // La boite englobante est memorisee sur le File : l'icone d'apercu peut
  // ensuite rebasculer l'estimation sur cette piece sans relire le fichier.
  extractDims(file).then(bbox => {
    if (!bbox) return;
    file._bbox = bbox;
    applyDims(bbox, file.name);
  }).catch(() => {});
}

// -- Apercu 3D : afficher une piece precise (icone de la liste de fichiers) --
// Le visualisateur vit dans un <script type="module"> separe : on communique
// par des ponts sur window, poses seulement si l'apercu est active.
//
// Afficher une piece et aligner l'estimation sur SES dimensions : le client
// voit toujours le prix de la piece qu'il a sous les yeux.
function showPiece(f) {
  if (!f) return;
  if (typeof window.T3D_VIEW_FILE === 'function') window.T3D_VIEW_FILE(f);
  if (f._bbox) { applyDims(f._bbox, f.name); return; }
  extractDims(f).then(function (bbox) {
    if (!bbox) return;
    f._bbox = bbox;
    applyDims(bbox, f.name);
  }).catch(function () {});
}

function previewFile(idx) {
  showPiece(S.files[idx]);
}

// Rappel du visualisateur : quel fichier est reellement affiche a l'ecran.
function onPreview(f) {
  S.preview = f || null;
  renderFileList();
}

function removeFile(idx) {
  const f = S.files[idx];
  if (!f) return;
  S.totalSize -= f.size;
  S.files.splice(idx, 1);
  S.fileError = S.totalSize > MAX_TOTAL_BYTES;

  // Si on a supprimé le fichier 3MF actif → repasser en volumétrique
  const has3mf = S.files.some(f => f.name.toLowerCase().endsWith('.3mf') && f._slicerData);
  if (!has3mf) {
    S.priceMode = 'volumetric';
    S.slicerData = null;
    document.getElementById('slicer-result').style.display = 'none';
  } else {
    // Prendre le dernier 3MF disponible
    const last3mf = S.files.filter(f => f._slicerData).pop();
    S.slicerData = last3mf ? last3mf._slicerData : null;
    S.priceMode = S.slicerData ? '3mf' : 'volumetric';
  }

  // Le fichier retire etait celui affiche dans l'apercu : on bascule sur la
  // piece previsualisable suivante, sinon on vide le visualisateur.
  if (S.preview === f) {
    S.preview = null;
    const next = S.files.filter(x => VIEWABLE.indexOf(x.name.split('.').pop().toLowerCase()) !== -1)[0];
    if (next) showPiece(next);
    else if (typeof window.T3D_CLEAR_VIEW === 'function') window.T3D_CLEAR_VIEW();
  }

  renderFileList();
  updateSizeBar(S.totalSize);
  syncFileInput();
  calcPrice();
}

// Synchronise <input type="file" id="file-input"> avec S.files via DataTransfer.
// Indispensable : le drag-and-drop ne remplit pas l'input nativement.
// Sans cette synchro, les fichiers droppés ne partiraient pas dans le POST.
function syncFileInput() {
  const input = document.getElementById('file-input');
  if (!input) return;
  try {
    const dt = new DataTransfer();
    S.files.forEach(f => dt.items.add(f));
    input.files = dt.files;
  } catch (e) {
    console.warn('[ToutEn3D] DataTransfer non supporté par ce navigateur — les fichiers droppés ne seront pas joints.', e);
  }
}

function renderFileList() {
  const list = document.getElementById('file-list');
  const zone = document.getElementById('upload-zone');

  if (S.files.length === 0) {
    list.innerHTML = '';
    zone.classList.remove('has-files');
    return;
  }

  zone.classList.add('has-files');
  list.innerHTML = S.files.map((f, i) => {
    const is3mf = f.name.toLowerCase().endsWith('.3mf');
    const hasData = !!f._slicerData;
    const cls = is3mf && hasData ? 'file-item has-3mf' : 'file-item';
    const ext = (f.name.split('.').pop() || '').toLowerCase();
    const canView = VIEWABLE.indexOf(ext) !== -1 && typeof window.T3D_VIEW_FILE === 'function';
    const shown = S.preview === f;
    const viewTip = shown ? 'Affiché dans l’aperçu 3D' : 'Voir cette pièce dans l’aperçu 3D';
    const viewBtn = canView
      ? `<span class="file-view${shown ? ' on' : ''}" onclick="previewFile(${i})" role="button" tabindex="0" title="${viewTip}">👁</span>`
      : '';
    const status = is3mf
      ? (hasData ? '<span class="file-status">✅ Slicé</span>' : '<span class="file-status" style="color:var(--muted)">3MF</span>')
      : '<span class="file-status" style="color:var(--muted)">'+f.name.split('.').pop().toUpperCase()+'</span>';
    return `<div class="${cls}">
      ${status}
      <span class="file-name">${f.name}</span>
      <span class="file-size">${(f.size/1024/1024).toFixed(2)} Mo</span>
      ${viewBtn}
      <span class="file-remove" onclick="removeFile(${i})" title="Retirer">✕</span>
    </div>`;
  }).join('');
}

function updateSizeBar(total) {
  const wrap  = document.getElementById('size-bar-wrap');
  const fill  = document.getElementById('size-bar-fill');
  const label = document.getElementById('size-bar-label');
  if (S.files.length === 0) { wrap.style.display = 'none'; return; }
  wrap.style.display = 'block';
  const pct   = Math.min(100, (total / MAX_TOTAL_BYTES) * 100);
  fill.style.width = pct + '%';
  fill.className    = 'size-bar-fill' + (pct >= 100 ? ' danger' : pct >= 80 ? ' warn' : '');
  const usedMb = (total/1024/1024).toFixed(1);
  const maxMb  = (MAX_TOTAL_BYTES/1024/1024).toFixed(0);
  label.textContent = usedMb + ' Mo utilisés sur ' + maxMb + ' Mo' + (pct >= 100 ? ' — limite dépassée !' : '');
  label.style.color  = pct >= 100 ? 'var(--danger)' : pct >= 80 ? 'var(--warn)' : 'var(--muted)';
  S.fileError = total > MAX_TOTAL_BYTES;
}

// ══════════════════════════════════════
// PARSING 3MF
// ══════════════════════════════════════
async function parse3MF(file) {
  if (!window.JSZip) throw new Error('JSZip non chargé');
  const zip = await JSZip.loadAsync(file);
  const sf  = zip.file('Metadata/slice_info.config') || zip.file(/slice_info/i)[0];
  let wG=null, pM=null, sG=0;
  if (sf) {
    const xml = await sf.async('text');
    const doc = new DOMParser().parseFromString(xml, 'text/xml');
    const fl  = doc.querySelector('filament');
    if (fl) { const g=fl.getAttribute('used_g'); if(g) wG=parseFloat(g); }
    const pt  = doc.querySelector('print_time') || doc.querySelector('estimatedPrintTime');
    if (pt) pM = parseTS(pt.textContent || pt.getAttribute('value') || '');
    const sup = doc.querySelector('support');
    if (sup) sG = parseFloat(sup.getAttribute('used_g') || '0');
  }
  if (!wG || !pM) {
    const mf = zip.file('Metadata/model_settings.config') || zip.file(/model_settings/i)[0];
    if (mf) {
      const xml = await mf.async('text');
      const mU = xml.match(/filament_used_weight[^>]*value="([^"]+)"/);
      const mT = xml.match(/estimated_printing_time[^>]*value="([^"]+)"/);
      if (mU) wG=parseFloat(mU[1]);
      if (mT) pM=parseTS(mT[1]);
    }
  }
  if (!wG && !pM) throw new Error('Aucune donnée de slicing');
  return { weightG:wG || S.x*S.y*S.z*0.0002*1.24, printMinutes:pM || S.x*S.y*S.z*0.002, supportG:sG };
}

function parseTS(s) {
  if(!s) return null; s=s.trim();
  if(s.includes(':')) { const p=s.split(':').map(Number); return p.length===3?p[0]*60+p[1]+p[2]/60:p[0]*60+p[1]; }
  let m=0;
  const h=s.match(/(\d+)\s*h/i), mi=s.match(/(\d+)\s*m/i), se=s.match(/(\d+)\s*s/i);
  if(h) m+=parseInt(h[1])*60; if(mi) m+=parseInt(mi[1]); if(se) m+=parseInt(se[1])/60;
  if(!h&&!mi&&!se) m=parseFloat(s)/60;
  return m||null;
}

function fmtT(m) { if(!m) return'—'; const h=Math.floor(m/60),mn=Math.round(m%60); return h>0?h+'h '+mn+'min':mn+' min'; }

function showSlicerResult(d) {
  const el = document.getElementById('slicer-result');
  el.style.display = 'block';
  el.innerHTML =
    '<div class="slicer-box">'
    +'<div style="margin-bottom:8px"><span class="slicer-badge">✅ Données de slicing extraites · précision ±5%</span></div>'
    +'<div class="slicer-row"><span>Poids filament</span><span>'+d.weightG.toFixed(1)+' g</span></div>'
    +(d.supportG>0?'<div class="slicer-row"><span>Support matériau</span><span>'+d.supportG.toFixed(1)+' g</span></div>':'')
    +'<div class="slicer-row"><span>Temps d\'impression</span><span>'+fmtT(d.printMinutes)+'</span></div>'
    +'</div>';
}

// ══════════════════════════════════════
// EXTRACTION AUTOMATIQUE DES DIMENSIONS
// ══════════════════════════════════════
async function extractDims(file) {
  const ext = file.name.split('.').pop().toLowerCase();
  if (ext === 'stl') return dimFromSTL(file);
  if (ext === 'obj') return dimFromOBJ(file);
  if (ext === '3mf') return dimFrom3MF(file);
  return null;
}

async function dimFromSTL(file) {
  const buf = await file.arrayBuffer();
  const header = new TextDecoder().decode(new Uint8Array(buf, 0, 5));
  let minX=Infinity, maxX=-Infinity, minY=Infinity, maxY=-Infinity, minZ=Infinity, maxZ=-Infinity;
  if (header.toLowerCase().startsWith('solid')) {
    // ASCII STL
    const text = new TextDecoder().decode(buf);
    for (const line of text.split('\n')) {
      const m = line.trim().match(/^vertex\s+([\d.eE+\-]+)\s+([\d.eE+\-]+)\s+([\d.eE+\-]+)/i);
      if (!m) continue;
      const x=parseFloat(m[1]), y=parseFloat(m[2]), z=parseFloat(m[3]);
      minX=Math.min(minX,x); maxX=Math.max(maxX,x);
      minY=Math.min(minY,y); maxY=Math.max(maxY,y);
      minZ=Math.min(minZ,z); maxZ=Math.max(maxZ,z);
    }
  } else {
    // STL binaire : 80 octets header | 4 uint32 nb triangles | 50 octets / triangle
    const view = new DataView(buf);
    const n = view.getUint32(80, true);
    let off = 84;
    for (let i = 0; i < n; i++) {
      off += 12; // ignorer la normale
      for (let v = 0; v < 3; v++) {
        const x=view.getFloat32(off,true), y=view.getFloat32(off+4,true), z=view.getFloat32(off+8,true);
        off += 12;
        minX=Math.min(minX,x); maxX=Math.max(maxX,x);
        minY=Math.min(minY,y); maxY=Math.max(maxY,y);
        minZ=Math.min(minZ,z); maxZ=Math.max(maxZ,z);
      }
      off += 2;
    }
  }
  if (!isFinite(minX)) return null;
  return { x: maxX-minX, y: maxY-minY, z: maxZ-minZ };
}

async function dimFromOBJ(file) {
  const text = await file.text();
  let minX=Infinity, maxX=-Infinity, minY=Infinity, maxY=-Infinity, minZ=Infinity, maxZ=-Infinity;
  for (const line of text.split('\n')) {
    if (!line.startsWith('v ')) continue;
    const p = line.trim().split(/\s+/);
    const x=parseFloat(p[1]), y=parseFloat(p[2]), z=parseFloat(p[3]);
    if (isNaN(x)||isNaN(y)||isNaN(z)) continue;
    minX=Math.min(minX,x); maxX=Math.max(maxX,x);
    minY=Math.min(minY,y); maxY=Math.max(maxY,y);
    minZ=Math.min(minZ,z); maxZ=Math.max(maxZ,z);
  }
  if (!isFinite(minX)) return null;
  return { x: maxX-minX, y: maxY-minY, z: maxZ-minZ };
}

async function dimFrom3MF(file) {
  if (!window.JSZip) return null;
  const zip = await JSZip.loadAsync(file);
  const mf = zip.file('3D/3dmodel.model') || zip.file(/3dmodel\.model$/i)[0];
  if (!mf) return null;
  const xml = await mf.async('text');
  const doc = new DOMParser().parseFromString(xml, 'text/xml');
  const verts = doc.querySelectorAll('vertex');
  if (!verts.length) return null;
  let minX=Infinity, maxX=-Infinity, minY=Infinity, maxY=-Infinity, minZ=Infinity, maxZ=-Infinity;
  verts.forEach(v => {
    const x=parseFloat(v.getAttribute('x')||'0'), y=parseFloat(v.getAttribute('y')||'0'), z=parseFloat(v.getAttribute('z')||'0');
    minX=Math.min(minX,x); maxX=Math.max(maxX,x);
    minY=Math.min(minY,y); maxY=Math.max(maxY,y);
    minZ=Math.min(minZ,z); maxZ=Math.max(maxZ,z);
  });
  if (!isFinite(minX)) return null;
  return { x: maxX-minX, y: maxY-minY, z: maxZ-minZ };
}

function applyDims(bbox, filename) {
  const x = Math.max(1, Math.ceil(bbox.x));
  const y = Math.max(1, Math.ceil(bbox.y));
  const z = Math.max(1, Math.ceil(bbox.z));
  if (x > 1000 || y > 1000 || z > 1000) {
    showDimNotice('⚠️ Dimensions extraites hors gabarit (' + x + '×' + y + '×' + z + ' mm). Vérifiez les unités du fichier (mètres ou pouces ?).', false);
    return;
  }
  document.getElementById('dim-x').value = x;
  document.getElementById('dim-y').value = y;
  document.getElementById('dim-z').value = z;
  S.x = x; S.y = y; S.z = z;
  updateDim();
  showDimNotice('📐 Dimensions extraites de <strong>' + filename + '</strong> : <strong>' + x + ' × ' + y + ' × ' + z + ' mm</strong>', true);
}

function showDimNotice(html, success) {
  const el = document.getElementById('dim-extract-result');
  if (!el) return;
  el.style.display = 'block';
  el.className = success ? 'notice-success' : 'notice-warn';
  el.innerHTML = html;
}

// ══════════════════════════════════════
// AUTOCOMPLÉTION ADRESSE — API BAN (api-adresse.data.gouv.fr)
// ══════════════════════════════════════
// API officielle française, gratuite, sans clé.
// DÉGRADATION GRACIEUSE : si l'appel échoue (CSP Shopify, réseau coupé,
// API indisponible), les champs restent 100% utilisables en saisie
// manuelle classique. L'autocomplétion est un confort, jamais un blocage.
var BAN_URL = 'https://api-adresse.data.gouv.fr/search/';
var acTimerAddr = null, acTimerZip = null;

function banFetch(params) {
  var qs = Object.keys(params).map(function(k) {
    return encodeURIComponent(k) + '=' + encodeURIComponent(params[k]);
  }).join('&');
  return fetch(BAN_URL + '?' + qs)
    .then(function(r) { if (!r.ok) throw new Error('BAN ' + r.status); return r.json(); })
    .then(function(d) { return (d && d.features) ? d.features : []; });
}

function escHtml(s) {
  return String(s).replace(/[&<>]/g, function(c) {
    return { '&': '&amp;', '<': '&lt;', '>': '&gt;' }[c];
  });
}
function escAttr(s) { return escHtml(s).replace(/"/g, '&quot;'); }

// — Champ Adresse : autocomplétion complète (rue + CP + ville) —
function acAddr(val) {
  var box = document.getElementById('addr-ac');
  val = (val || '').trim();
  clearTimeout(acTimerAddr);
  if (val.length < 4) { box.classList.remove('show'); box.innerHTML = ''; return; }
  acTimerAddr = setTimeout(function() {
    var zip = (document.getElementById('zip').value || '').trim();
    var params = { q: val, limit: 6, autocomplete: 1 };
    if (/^\d{5}$/.test(zip)) params.postcode = zip;
    banFetch(params).then(function(feats) {
      if (!feats.length) { box.classList.remove('show'); box.innerHTML = ''; return; }
      box.innerHTML = feats.map(function(f) {
        var p = f.properties;
        return '<li class="cd-ac-item"'
          + ' data-name="' + escAttr(p.name || p.label) + '"'
          + ' data-zip="'  + escAttr(p.postcode || '') + '"'
          + ' data-city="' + escAttr(p.city || '') + '">'
          + escHtml(p.name || p.label)
          + ' <span class="cd-ac-city">' + escHtml(((p.postcode || '') + ' ' + (p.city || '')).trim()) + '</span>'
          + '</li>';
      }).join('');
      box.classList.add('show');
      Array.prototype.forEach.call(box.querySelectorAll('.cd-ac-item'), function(li) {
        li.addEventListener('mousedown', function(e) {
          e.preventDefault();
          document.getElementById('addr').value = li.getAttribute('data-name');
          if (li.getAttribute('data-zip'))  document.getElementById('zip').value  = li.getAttribute('data-zip');
          if (li.getAttribute('data-city')) document.getElementById('city').value = li.getAttribute('data-city');
          box.classList.remove('show'); box.innerHTML = '';
        });
      });
    }).catch(function() {
      box.classList.remove('show'); box.innerHTML = '';  // API injoignable → saisie manuelle
    });
  }, 280);
}

// — Champ Code postal : suggestion de ville —
function acZip(val) {
  var box   = document.getElementById('zip-ac');
  var clean = (val || '').replace(/\D/g, '').slice(0, 5);
  document.getElementById('zip').value = clean;
  clearTimeout(acTimerZip);
  if (clean.length !== 5) { box.classList.remove('show'); box.innerHTML = ''; return; }
  acTimerZip = setTimeout(function() {
    banFetch({ q: clean, type: 'municipality', limit: 8 }).then(function(feats) {
      var comm = feats.filter(function(f) { return f.properties.postcode === clean; });
      var list = comm.length ? comm : feats;
      if (!list.length) { box.classList.remove('show'); box.innerHTML = ''; return; }
      if (list.length === 1) {
        document.getElementById('city').value = list[0].properties.city || list[0].properties.name;
        box.classList.remove('show'); box.innerHTML = '';
        return;
      }
      box.innerHTML = list.map(function(f) {
        var c = f.properties.city || f.properties.name;
        return '<li class="cd-ac-item" data-city="' + escAttr(c) + '">' + escHtml(c) + '</li>';
      }).join('');
      box.classList.add('show');
      Array.prototype.forEach.call(box.querySelectorAll('.cd-ac-item'), function(li) {
        li.addEventListener('mousedown', function(e) {
          e.preventDefault();
          document.getElementById('city').value = li.getAttribute('data-city');
          box.classList.remove('show'); box.innerHTML = '';
        });
      });
    }).catch(function() {
      box.classList.remove('show'); box.innerHTML = '';  // API injoignable → saisie manuelle
    });
  }, 280);
}

// Fermer les listes de suggestions au clic en dehors
document.addEventListener('click', function(e) {
  if (!e.target.closest('.cd-ac-field')) {
    var a = document.getElementById('addr-ac'), z = document.getElementById('zip-ac');
    if (a) a.classList.remove('show');
    if (z) z.classList.remove('show');
  }
});

// ══════════════════════════════════════
// SUBMIT — POST natif vers FormSubmit
// ══════════════════════════════════════
// Architecture : <form action="WORKER_URL.workers.dev" method="POST" enctype="multipart/form-data">
// - Validation côté client
// - Synchronisation des hidden inputs depuis l'état S
// - Construction dynamique du texte d'accusé de réception
// - return true → soumission native du navigateur
// - FormSubmit affiche reCAPTCHA → envoie email + accusé → redirige vers _next
// Mode de livraison : etat visuel de l'option choisie.
// Appelee par les onclick du HTML depuis toujours, mais jamais ecrite :
// chaque clic levait un ReferenceError. Le surlignage principal passe par
// :has(input:checked) en CSS, la classe .selected sert de repli.
function selectDelivery(el) {
  document.querySelectorAll('#delivery-options .delivery-opt')
    .forEach(function (o) { o.classList.remove('selected'); });
  if (el) el.classList.add('selected');
  const err = document.getElementById('delivery-err');
  if (err) err.style.display = 'none';
}

function prepareSubmit(event) {
  const fn = document.getElementById('fname').value.trim();
  const ln = document.getElementById('lname').value.trim();
  const em = document.getElementById('email').value.trim();
  const addr = document.getElementById('addr').value.trim();
  const zip  = document.getElementById('zip').value.trim();
  const city = document.getElementById('city').value.trim();
  const fileUrl = (document.getElementById('file-url').value || '').trim();
  const rightsOk = document.getElementById('rights-check').checked;
  const usageVal = (document.getElementById('usage') ? document.getElementById('usage').value : '').trim();

  // ── Usage & contraintes obligatoires (étape 2) ──
  if (S.constraints.length === 0 || usageVal.length < 3) {
    event.preventDefault();
    alert('Merci d’indiquer l’usage de votre pièce et au moins une contrainte (étape 2).');
    goTo(2);
    setTimeout(() => {
      const t = document.getElementById(S.constraints.length === 0 ? 'constraint-grid' : 'usage');
      const e = document.getElementById(S.constraints.length === 0 ? 'constraints-err' : 'usage-err');
      if (e) e.style.display = 'block';
      if (t) t.scrollIntoView({behavior:'smooth', block:'center'});
    }, 100);
    return false;
  }

  // ── Validations bloquantes ──
  if (!fn) {
    event.preventDefault();
    alert('Merci de renseigner votre prénom.');
    goTo(4);
    setTimeout(() => document.getElementById('fname').focus(), 100);
    return false;
  }
  if (!ln) {
    event.preventDefault();
    alert('Merci de renseigner votre nom.');
    goTo(4);
    setTimeout(() => document.getElementById('lname').focus(), 100);
    return false;
  }
  if (!em || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(em)) {
    event.preventDefault();
    alert('Merci de renseigner un email valide.');
    goTo(4);
    setTimeout(() => document.getElementById('email').focus(), 100);
    return false;
  }
  if (!addr) {
    event.preventDefault();
    alert('Merci de renseigner votre adresse postale.');
    goTo(4);
    setTimeout(() => document.getElementById('addr').focus(), 100);
    return false;
  }
  if (!/^\d{5}$/.test(zip)) {
    event.preventDefault();
    alert('Merci de renseigner un code postal valide (5 chiffres).');
    goTo(4);
    setTimeout(() => document.getElementById('zip').focus(), 100);
    return false;
  }
  if (!city) {
    event.preventDefault();
    alert('Merci de renseigner votre ville.');
    goTo(4);
    setTimeout(() => document.getElementById('city').focus(), 100);
    return false;
  }
  if (!document.querySelector('input[name="Mode_livraison"]:checked')) {
    event.preventDefault();
    alert('Merci de choisir un mode de livraison.');
    goTo(4);
    setTimeout(() => {
      const err = document.getElementById('delivery-err');
      if (err) err.style.display = 'block';
      const box = document.getElementById('delivery-options');
      if (box) box.scrollIntoView({behavior:'smooth', block:'center'});
    }, 100);
    return false;
  }
  if (S.fileError || S.totalSize > MAX_TOTAL_BYTES) {
    event.preventDefault();
    alert('La taille totale des fichiers dépasse 10 Mo. Retirez un fichier ou partagez un lien dans le champ URL.');
    goTo(1);
    return false;
  }
  if ((S.files.length > 0 || fileUrl) && !rightsOk) {
    event.preventDefault();
    alert('Merci de cocher la case de confirmation des droits du fichier 3D avant de continuer.');
    goTo(1);
    setTimeout(() => {
      document.getElementById('rights-err').style.display = 'block';
      document.getElementById('rights-check').scrollIntoView({behavior:'smooth', block:'center'});
    }, 300);
    return false;
  }

  // ── Synchronisation des hidden inputs depuis S ──
  const prixEstime = document.getElementById('pb-total').textContent;
  const assy = needsAssy(S.x, S.y, S.z);

  function setHF(id, val) {
    const el = document.getElementById(id);
    if (el) el.value = (val == null) ? '' : String(val);
  }

  setHF('hf-replyto',      em);
  setHF('hf-materiau',     MAT_L[S.material]);
  setHF('hf-couleur',      S.color);
  setHF('hf-texture',      S.texture + (S.texture !== 'Textured' ? ' (+5%)' : ''));
  setHF('hf-qualite',      QUAL_L[S.quality]);
  setHF('hf-resistance',   RES_ON ? RES_L[S.resistance] : 'Standard');
  setHF('hf-quantite',     S.qty + ' piece' + (S.qty > 1 ? 's' : ''));
  setHF('hf-dimensions',   S.x + ' x ' + S.y + ' x ' + S.z + ' mm' + (assy ? ' (hors gabarit +' + ASSY + ' EUR/piece)' : ''));
  setHF('hf-prioritaire',  S.urgent ? 'Oui (+50%)' : 'Non');
  setHF('hf-finition',     S.finish ? 'Oui (+30%)' : 'Non');
  setHF('hf-contraintes',  S.constraints.length ? S.constraints.map(function(c){return CONSTRAINT_L[c]||c;}).join(', ') : '-');
  setHF('hf-prix',         prixEstime);
  setHF('hf-source-prix',  S.priceMode === '3mf' ? '3MF slice (+-5%)' : 'Volumetrique (+-15%)');
  setHF('hf-droits',       rightsOk ? 'Oui (certifie par le client)' : 'Non requis (aucun fichier)');
  setHF('hf-url',          fileUrl || '-');

  if (S.slicerData) {
    setHF('hf-poids', S.slicerData.weightG.toFixed(1) + ' g');
    setHF('hf-temps', fmtT(S.slicerData.printMinutes));
  } else {
    setHF('hf-poids', '-');
    setHF('hf-temps', '-');
  }

  if (S.files.length > 0) {
    const names = S.files.map(f => f.name + ' (' + (f.size/1024/1024).toFixed(2) + ' Mo)');
    setHF('hf-fichiers', names.join(' | '));
  } else {
    setHF('hf-fichiers', fileUrl ? 'Via URL (voir champ URL_fichier)' : 'Aucun');
  }

  // ── Construction de l'accusé de réception (envoyé automatiquement par FormSubmit au client) ──
  const optsList = [];
  if (S.urgent) optsList.push('fabrication prioritaire (+50%)');
  if (S.finish) optsList.push('finition post-impression (+30%)');
  if (assy)     optsList.push('assemblage hors gabarit (+' + ASSY + ' €/pièce)');
  const optsLine = optsList.length ? '  • Options      : ' + optsList.join(', ') + '\n' : '';
  const remiseLine = S.qty >= 2 ? '  • Remise série : ' + discTxt(S.qty) + ' appliquée\n' : '';
  const slicingNote = S.priceMode === '3mf'
    ? 'données slicing 3MF, marge ±5%'
    : 'estimation volumétrique, marge ±15%';

  const contraintesTxtA = S.constraints.length
    ? S.constraints.map(function(c){return CONSTRAINT_L[c]||c;}).join(', ')
    : '—';
  const prioLine = S.urgent
    ? 'Votre option « fabrication prioritaire » est bien prise en compte : nous traitons votre demande en priorité.\n\n'
    : '';

  // Resistance : affichee seulement si le selecteur est actif dans la section
  const resLine = RES_ON
    ? '  • Résistance   : ' + (RES_L[S.resistance] || 'Standard') + '\n'
    : '';

  // Mode de livraison choisi a l'etape 4 — les frais ne sont pas chiffres ici
  const delEl = document.querySelector('input[name="Mode_livraison"]:checked');
  const livraisonTxt = delEl ? delEl.value : 'à préciser';

  const autoresponseText =
    'Bonjour ' + fn + ',\n\n' +
    'Merci d\'avoir utilisé notre générateur de devis en ligne ToutEn3D !\n\n' +
    'Votre demande est bien arrivée et nous l\'étudions dès maintenant. S\'il nous manque une information pour chiffrer précisément votre pièce (usage, contraintes, matière…), nous reviendrons vers vous rapidement — avant de vous transmettre le devis final. C\'est ce qui nous permet de vous proposer un prix juste, sans mauvaise surprise.\n\n' +
    prioLine +
    'Sans élément manquant, vous recevez votre devis détaillé sous 2 à 3 jours ouvrés.\n\n' +
    '─── Récapitulatif de votre demande ───\n' +
    '  • Usage        : ' + (usageVal || '—') + '\n' +
    '  • Contraintes  : ' + contraintesTxtA + '\n' +
    '  • Dimensions   : ' + S.x + ' × ' + S.y + ' × ' + S.z + ' mm\n' +
    '  • Quantité     : ' + S.qty + ' pièce' + (S.qty > 1 ? 's' : '') + '\n' +
    '  • Matériau     : ' + MAT_L[S.material] + '\n' +
    '  • Couleur      : ' + S.color + '\n' +
    '  • Texture      : ' + S.texture + '\n' +
    '  • Qualité      : ' + QUAL_L[S.quality] + '\n' +
    resLine +
    optsLine + remiseLine +
    '  • Estimation   : ' + prixEstime + '\n' +
    '  • Livraison    : ' + livraisonTxt + '\n\n' +
    'Cette estimation est indicative (' + slicingNote + ') et ne comprend pas les frais de livraison : ceux-ci sont calculés et ajoutés au moment du devis final. Celui-ci intègrera également les ajustements liés à la géométrie réelle, à l\'orientation d\'impression et aux contraintes spécifiques de votre projet.\n\n' +
    'Une précision à apporter ? Répondez simplement à cet email.\n\n' +
    'À très vite,\n' +
    'L\'équipe ToutEn3D\n' +
    '✉ touten3d.info@gmail.com\n' +
    '🌐 toutentroisd.fr';

  setHF('hf-autoresponse', autoresponseText);

  // ── Envoi AJAX vers le Worker Cloudflare ──
  // (plus de reCAPTCHA, plus de redirection, écran succès inline)
  event.preventDefault();
  const form = document.getElementById('quote-form');
  const btn  = document.getElementById('submit-btn');
  const lo   = document.getElementById('cd-loading-overlay') || document.getElementById('loading-overlay');

  if (lo) lo.classList.add('show');
  btn.disabled    = true;
  btn.textContent = '⏳ Envoi en cours…';

  fetch(form.action, { method: 'POST', body: new FormData(form) })
    .then(function(res) { return res.json(); })
    .then(function(data) {
      if (lo) lo.classList.remove('show');
      if (data && data.success) {
        showOK(fn);
      } else {
        btn.disabled    = false;
        btn.textContent = '🚀 Envoyer ma demande';
        alert('Erreur lors de l\'envoi : ' + ((data && data.error) || 'Erreur inconnue')
          + '\n\nMerci de réessayer ou de nous écrire à touten3d.info@gmail.com');
      }
    })
    .catch(function() {
      if (lo) lo.classList.remove('show');
      btn.disabled    = false;
      btn.textContent = '🚀 Envoyer ma demande';
      alert('Erreur réseau. Merci de réessayer ou de nous écrire à touten3d.info@gmail.com');
    });

  return false; // Toujours false — le fetch gère tout
}

// Affiche l'écran de succès inline (plus de redirection)
function showOK(prenom) {
  const stepper = document.querySelector('.stepper');
  const formArea = document.getElementById('form-area');
  const priceSide = document.querySelector('.price-box') && document.querySelector('.price-box').parentElement;
  if (stepper)   stepper.style.display   = 'none';
  if (formArea)  formArea.style.display  = 'none';
  if (priceSide) priceSide.style.display = 'none';
  const ss = document.getElementById('success-screen');
  if (ss) ss.classList.add('show');
  const sn = document.getElementById('success-name');
  if (sn) sn.textContent = prenom;
  try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch(e) {}
}

// ══════════════════════════════════════
// INIT
// ══════════════════════════════════════
calcPrice();

  // ── Exports globaux pour handlers inline ──
  if (typeof prepareSubmit !== 'undefined') window.prepareSubmit = prepareSubmit;
  if (typeof updateDim !== 'undefined') window.updateDim = updateDim;
  if (typeof updateQty !== 'undefined') window.updateQty = updateQty;
  if (typeof goTo !== 'undefined') window.goTo = goTo;
  if (typeof step1Next !== 'undefined') window.step1Next = step1Next;
  if (typeof step2Next !== 'undefined') window.step2Next = step2Next;
  if (typeof handleDrop !== 'undefined') window.handleDrop = handleDrop;
  if (typeof handleFiles !== 'undefined') window.handleFiles = handleFiles;
  if (typeof removeFile !== 'undefined') window.removeFile = removeFile;
  if (typeof previewFile !== 'undefined') window.previewFile = previewFile;
  if (typeof selectDelivery !== 'undefined') window.selectDelivery = selectDelivery;
  if (typeof onPreview !== 'undefined') window.T3D_ON_PREVIEW = onPreview;
  if (typeof selectTexture !== 'undefined') window.selectTexture = selectTexture;
  if (typeof toggleOption !== 'undefined') window.toggleOption = toggleOption;
  if (typeof toggleRights !== 'undefined') window.toggleRights = toggleRights;
  if (typeof toggleChip !== 'undefined') window.toggleChip = toggleChip;
  if (typeof acAddr !== 'undefined') window.acAddr = acAddr;
  if (typeof acZip !== 'undefined') window.acZip = acZip;

  calcPrice();
})();